import * as actionType from './actions/QuotationActions';

const initialState = {
    list: [],
    message: '',
    modalOpen: false,
    loading: false,
    isQuotationOrderEdit: false,
    isQuotationOrderList: true,
    apiStatus: false,
    QuotationHistory:[]
}
const QuotationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.Get_ALL_QUOTATIONS:
            return { ...state, isQuotationOrderList: false, isQuotationOrderEdit: false, message: "",  QuotationsList: action.payload }
        case actionType.QUOTATION_ITEM_DETAILS:
            return { ...state, loading: false, modalOpen: false, isQuotationOrderList: false, isQuotationOrderEdit: false, message: "",  QuotationDetailsData: action.payload }
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading,apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message}
        case actionType.IS_QUATATION_LIST:
            return { ...state, modalOpen: false, loading: false,isQuotationOrderEdit:false,isQuotationOrderList:action.payload }     
            case actionType.QUOTATION_REMARKS:
            return{ ...state,modalOpen:false, loading:false,isQuotationOrderEdit:false, QuotationHistory:action.payload}
                
        case actionType.CLEAR_MESSAGESS:
            return { ...state, modalOpen: false, loading: false,isQuotationOrderEdit:false,isQuotationOrderList:false,message:"" }             
        default:
            return state
    }
}
export default QuotationReducer